var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.37 56.704a18.333 18.333 0 0112.963-5.37h29.334A18.333 18.333 0 0177 69.667v7.334a3.667 3.667 0 01-7.333 0v-7.334a11 11 0 00-11-11H29.333a11 11 0 00-11 11v7.334A3.667 3.667 0 0111 77v-7.334c0-4.862 1.931-9.525 5.37-12.963zM44 14.667c-6.075 0-11 4.925-11 11s4.925 11 11 11 11-4.925 11-11-4.925-11-11-11zm-18.333 11c0-10.125 8.208-18.333 18.333-18.333 10.126 0 18.334 8.208 18.334 18.333 0 10.125-8.209 18.334-18.334 18.334s-18.333-8.209-18.333-18.334z",
    fill: "#FFD600"
  })));
}
export default __webpack_public_path__ + "img/_/_/views/utils/components/Header/assets/svg/user.svg";
export { SvgUser as ReactComponent };